import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';
import './topMenuIcon.css';

const TopMenuIcon = ({ collapse, setCollapse }) => (
  <Tooltip title={collapse ? 'Expand navigation' : 'Collapse navigation'}>
    <IconButton
      className="top_menu_icon"
      aria-label={collapse ? 'Expand navigation' : 'Collapse navigation'}
      aria-expanded={!collapse}
      aria-controls="silkcart-navigation"
      onClick={() => setCollapse(!collapse)}
    >
      {collapse ? <MenuRoundedIcon fontSize="small" /> : <MenuOpenRoundedIcon fontSize="small" />}
    </IconButton>
  </Tooltip>
);
export default TopMenuIcon;
